export const types = {
    SET_GET_WITHDRAWALS_LIST: '[WITHDRAWALS] SET GET WITHDRAWALS LIST',
    SET_GET_WITHDRAWALS_BY_ID: '[WITHDRAWALS] SET GET WITHDRAWALS BY ID'
}